import { supabase } from '../lib/supabaseClient';

/**
 * Inicia sesión con email y contraseña utilizando la API v2 de Supabase
 */
export const loginUser = async (credentials) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: credentials.email?.trim(),
    password: credentials.password,
  });

  if (error) throw error;

  const user = data.user;
  if (!user) return null;

  // Obtener información adicional del usuario si existe en la tabla usuarios
  try {
    const { data: userData, error: userError } = await supabase
      .from('usuarios')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();

    if (!userError && userData) {
      return { ...user, ...userData };
    }
  } catch (err) {
    console.warn('No se pudo obtener información adicional de perfil:', err);
  }

  return user;
};

/**
 * Obtiene el usuario actual con sesión activa
 */
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error || !user) return null;

  try {
    const { data: userData } = await supabase
      .from('usuarios')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();

    return userData ? { ...user, ...userData } : user;
  } catch (err) {
    return user;
  }
};

/**
 * Envía un correo con el enlace seguro para restablecer la contraseña
 */
export const resetPassword = async (email) => {
  const redirectUrl = `${window.location.origin}/actualizar-contrasena`;
  const { data, error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
    redirectTo: redirectUrl,
  });

  if (error) throw error;
  return data;
};

/**
 * Actualiza la contraseña del usuario cuando accede desde el link de restablecimiento
 */
export const updatePassword = async (newPassword) => {
  const { data, error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  if (error) throw error;
  return data;
};

/**
 * Cierra la sesión activa
 */
export const logoutUser = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};